import { type PropsWithChildren, createContext, useContext, useMemo } from 'react';

import { ThemeProvider } from '@mui/material/styles';

import { usePersistedSetting } from '../common/hooks/usePersistedSetting';
import { PortalThemeName, portalThemes } from './default';

const PORTAL_THEME_STORAGE_KEY = 'portal.theme';

type PortalThemeContextValue = {
	themeName: PortalThemeName;
	setThemeName: (themeName: PortalThemeName) => void;
};

const PortalThemeContext = createContext<PortalThemeContextValue>({ themeName: 'dark-main', setThemeName: () => undefined });

export function PortalThemeProvider({ children }: PropsWithChildren) {
	const [themeName, setThemeName] = usePersistedSetting<PortalThemeName>(PORTAL_THEME_STORAGE_KEY, 'dark-main');
	const value = useMemo(() => ({ themeName, setThemeName }), [themeName, setThemeName]);

	return (
		<PortalThemeContext.Provider value={value}>
			<ThemeProvider theme={portalThemes[themeName] ?? portalThemes['dark-main']}>{children}</ThemeProvider>
		</PortalThemeContext.Provider>
	);
}

export function usePortalTheme() {
	return useContext(PortalThemeContext);
}
